import gql from 'graphql-tag';
import apollo from '../services/apollo';

const TOGGLE_SUB_QUERY = gql`
  mutation toggleSubscribeAssessment($toggleInput: ToggleSubscribeAssessmentInput!) {
    toggleSubscribeAssessment(input: $toggleInput) {
      assessment {
        id
        subscribed
      }
    }
  }
`;

const SEND_REMIND_QUERY = gql`
  mutation remindRespondentTakeAssessment($input: RemindRespondentTakeAssessmentInput!) {
    remindRespondentTakeAssessment(input: $input) {
      clientMutationId
      assessment {
        id
        status
      }
    }
  }
`;

const SEND_INVITATION = gql`
  mutation($input: InviteRespondentTakeAssessmentInput!) {
    inviteRespondentTakeAssessment(input: $input) {
      clientMutationId
      assessment {
        id
        status
        invitedOn
      }
    }
  }
`;

const RESET_ASSESSMENT_DECLINE = gql`
  mutation resetAssessmentDeclinedStatus($input: ResetAssessmentDeclinedStatusInput!) {
    resetAssessmentDeclinedStatus(input: $input) {
      assessment {
        id
        status
      }
    }
  }
`;
class AssessmentNotify {
  /**
   * Toggle subscribing assessment
   * @param {String} assessmentId
   * @param {boolean} subscribed
   * @return {Promise}
   */
  static subscribe(assessmentId, subscribed) {
    return apollo.mutate({
      mutation: TOGGLE_SUB_QUERY,
      variables: {
        toggleInput: {
          assessmentId,
          subscribed,
        },
      },
    });
  }

  /**
   * send reminding email to respondent
   * @param {String} assessmentId
   * @param {String} respondentId
   * @return {Promise}
   */
  static sendRemind(assessmentId, accountId) {
    return apollo.mutate({
      mutation: SEND_REMIND_QUERY,
      variables: {
        input: {
          assessmentId,
          accountId,
        },
      },
    });
  }

  /**
   * send Invitation email to respondent
   * @param {String} assessmentId
   * @param {String} respondentId
   * @return {Promise}
   */
  static sendInvitation(assessmentId, accountId) {
    return apollo.mutate({
      mutation: SEND_INVITATION,
      variables: {
        input: {
          assessmentId,
          accountId,
        },
      },
    });
  }

  static resetAssessmentDecline(accountId, assessmentId) {
    return apollo.mutate({
      mutation: RESET_ASSESSMENT_DECLINE,
      variables: {
        input: {
          accountId,
          assessmentId,
        },
      },
    });
  }
}

export default AssessmentNotify;
